import { render } from "./TransactionDetails.vue?vue&type=template&id=69cd30b2&scoped=true"
import script from "./TransactionDetails.vue?vue&type=script&lang=js"
export * from "./TransactionDetails.vue?vue&type=script&lang=js"

import "./TransactionDetails.vue?vue&type=style&index=0&id=69cd30b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69cd30b2"

export default script